export default __webpack_public_path__ + "static/media/assetTradeIcon5.d0e9e99b.webp";